exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.is-wide[data-v-74affc18]{width:550px}.column-blanco[data-v-74affc18]{padding-bottom:100px}.card.has-text-centered .card-content[data-v-74affc18],.card.has-text-centered .card-footer[data-v-74affc18],.card.has-text-centered .card-header[data-v-74affc18]{justify-content:center;align-items:center}.card.has-text-centered h1[data-v-74affc18]{font-size:1.75rem;font-weight:700}.card-header[data-v-74affc18]{padding:1.75rem 0}.card-content[data-v-74affc18]{padding:3.5rem 0}.card-footer[data-v-74affc18]{padding:1rem 0;border:none;font-size:.9rem;color:gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74affc18","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sca_Componentes/acceso/Salida.vue
// module id = 1909
// module chunks = 0